import regions from '../_regions';

export default {
    namespaced: true,
    state: {
        progress: 0
    },
    actions: {
        update ({rootState, state, commit, dispatch}) {
            const progress = Math.floor(rootState.regions.regions.reduce((res, region) => (res + region.progress), 0) / regions.length)

            if (state.progress !== progress && progress % 5 === 0) {
                dispatch('balance/add', 2, {root: true})
                dispatch('history/push', {message: `+2ball for every 5% game progress`, theme: 'success'}, {root: true})
            }

            commit('progress', progress)
        },
        reset ({commit}) {
            commit('reset')
        }
    },
    mutations: {
        progress (state, value) {
            state.progress = value
        },
        reset (state) {
            state.progress = 0
        }
    }
}
